import { useEffect, useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';

const SEOHead = () => {
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    // Update document title based on language
    document.title = language === 'en' 
      ? 'AI Kitchen Chef - Transform Ingredients Into Amazing Recipes | AI Cooking Assistant'
      : 'AI Kitchen Chef - Przekształć Składniki W Niesamowite Przepisy | Asystent Kulinarny AI';

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        language === 'en'
          ? 'Simply take a photo of your ingredients and let AI create personalized recipes. Smart ingredient recognition, personalized meal suggestions, and reduce food waste with AI Kitchen Chef.'
          : 'Po prostu zrób zdjęcie swoich składników i pozwól AI stworzyć spersonalizowane przepisy. Inteligentne rozpoznawanie składników, spersonalizowane sugestie posiłków i zmniejszanie marnowania żywności z AI Kitchen Chef.'
      );
    }

    // Update HTML lang attribute
    document.documentElement.lang = language === 'en' ? 'en' : 'pl';

    // Update Open Graph locale
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) {
      ogLocale.setAttribute('content', language === 'en' ? 'en_US' : 'pl_PL');
    }
  }, [language]);

  return null;
};

export default SEOHead;

